import type { PremiumInvitePublicConfig } from "@/lib/premiumInvitePublicConfig";
import { normalizePublicOutboundUrl } from "@/lib/telegramPublicInviteUrl";
import { TELEGRAM_GROUP_URL } from "@/config/telegramGroups";

/**
 * URL del canal Telegram **gratis** (admin Invitación premium → `free_telegram_url`, o env).
 * Misma regla que `/invitacion-premium` y que la home con `BioTemplatePremiumSimple`.
 *
 * Cascada: admin → env (VITE_PREMIUM_SIMPLE_FREE_TELEGRAM_URL) → TELEGRAM_GROUP_URL
 * (default global en src/config/telegramGroups.ts → https://t.me/juanaperrone).
 */
export function resolvePremiumInviteFreeTelegramUrl(
  publicConfig: PremiumInvitePublicConfig | null | undefined,
): string | undefined {
  const fromAdmin = publicConfig?.free_telegram_url?.trim() ?? "";
  const fromEnv = (
    import.meta.env.VITE_PREMIUM_SIMPLE_FREE_TELEGRAM_URL as string | undefined
  )?.trim() ?? "";
  const fallback = (TELEGRAM_GROUP_URL ?? "").trim();
  const merged = (fromAdmin || fromEnv || fallback).trim();
  const normalized = normalizePublicOutboundUrl(merged);
  return normalized || undefined;
}
